// @ts-nocheck
// Resolves whether the current user has access to chapters 2-12.
// Calls the SQL function user_has_access(uid) introduced in migration 0009.
// Access is granted if EITHER (a) the user has an active license (paid via
// Lemon Squeezy webhook) OR (b) the user has claimed a reviewer invitation.
//
// Returns { hasAccess: boolean, loading: boolean, refresh: () => Promise<void> }.
// `refresh` is exposed so the /payment-success page can poll without remounting.

import { useCallback, useEffect, useState } from "react";
import { supabase } from "./supabase";
import { useAuth } from "./useAuth";

export function useAccess() {
  const { user, loading: authLoading } = useAuth();
  const [hasAccess, setHasAccess] = useState<boolean | null>(null);

  const check = useCallback(async () => {
    if (!user) {
      setHasAccess(false);
      return;
    }
    const { data, error } = await supabase.rpc("user_has_access", {
      uid: user.id,
    });
    if (error) {
      console.error("user_has_access rpc failed", error);
      setHasAccess(false);
      return;
    }
    setHasAccess(!!data);
  }, [user]);

  useEffect(() => {
    if (authLoading) return;
    check();
  }, [authLoading, check]);

  return {
    hasAccess: hasAccess === true,
    loading: authLoading || hasAccess === null,
    refresh: check,
  };
}
